import { calendarItems, calendarList, dayLabel, dayStrip, eventsRequest, timeLabel, viewWindow } from '../../lib/calendar.js'
import { wallText } from '../../lib/time.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- calendar-day-strip ---
let __fez_component_0;
{
const ROW = 26
__fez_component_0 = class {
  PROPS = {
    day: String,
    slot: { type: Object, default: null },
  }

  init() {
    this.state.loading = true
    this.state.error = ''
    this.state.raw = []
    this.state.seq = 0
  }

  onRefresh(props, changed) {
    if ('day' in changed) this.load()
  }

  valid() {
    return /^\d{4}-\d{2}-\d{2}$/.test(this.props.day || '')
  }

  async load() {
    const seq = ++this.state.seq
    if (!this.valid()) {
      this.state.raw = []
      this.state.loading = false
      return
    }
    const { path, params } = eventsRequest(viewWindow([this.props.day]))
    try {
      const result = await window.App.api(path, params, { silent: true })
      if (seq !== this.state.seq) return
      this.state.raw = result.items
      this.state.error = ''
    } catch (error) {
      if (seq === this.state.seq) this.state.error = error.message
    } finally {
      if (seq === this.state.seq) this.state.loading = false
    }
  }

  beforeRender() {
    const day = this.props.day
    this.state.shown = this.valid()
    if (!this.state.shown) return
    const items = calendarItems(this.state.raw, calendarList(this.globalState.mailboxes, [], [], this.globalState.mailboxSession ? '' : this.globalState.me?.ref), this.globalState.mailboxSession)
    const strip = dayStrip(items, day, this.props.slot)
    // Labels stay apart on a narrow dialog: every hour up to 7, every other one to 19, else every third.
    const every = strip.hours.length > 19 ? 3 : strip.hours.length > 7 ? 2 : 1
    this.state.title = `Your day: ${dayLabel(day, { weekday: 'long', month: 'long', day: 'numeric' })}`
    this.state.hours = strip.hours.map((tick, index) => ({
      ...tick,
      label: index % every || tick.hour === 24 ? '' : wallText(new Date(Date.UTC(2000, 0, 1, tick.hour)), { hour: 'numeric' }),
      // The first label starts at the strip's edge and the last ends at the other.
      edge: index === 0 ? 'first' : index === strip.hours.length - 1 ? 'last' : '',
    }))
    this.state.allDay = strip.allDay
    this.state.boxes = strip.boxes.map((box) => ({ ...box, top: box.row * ROW, range: `${timeLabel(box.startAt)} - ${timeLabel(box.endAt)}` }))
    this.state.height = strip.rows * ROW
    this.state.slot = strip.slot
    this.state.note = this.state.error || (this.state.loading ? '' : strip.boxes.length || strip.allDay.length ? '' : 'Nothing else in your calendar that day.')
  }

  CSS = `:fez {
display:block;.ds-head{display:flex;align-items:center;gap:var(--space-2);margin-bottom:var(--space-2);font-size:var(--text-sm);font-weight:var(--weight-semibold)}.ds-chips{display:flex;flex-wrap:wrap;gap:var(--space-1);margin-bottom:var(--space-2)}.ds-chip{max-width:100%;padding:1px var(--space-2);overflow:hidden;border-radius:var(--radius-sm);background:color-mix(in srgb,var(--tag) 16%,var(--color-bg-raised));font-size:var(--text-xs);text-overflow:ellipsis;white-space:nowrap}.ds-track{position:relative;margin-bottom:var(--space-4);border-top:1px solid var(--color-border);border-bottom:1px solid var(--color-border);background:var(--color-bg-subtle)}.ds-tick{position:absolute;top:0;bottom:0;border-left:1px solid var(--color-border)}.ds-hour{position:absolute;top:calc(100% + 2px);color:var(--color-text-subtle);font-size:var(--text-xs);line-height:var(--leading-tight);white-space:nowrap;transform:translateX(-50%);&.first{transform:none}&.last{transform:translateX(-100%)}}.ds-box{position:absolute;min-width:0;padding:2px var(--space-1);overflow:hidden;border-left:3px solid var(--tag);border-radius:var(--radius-sm);background:color-mix(in srgb,var(--tag) 16%,var(--color-bg-raised));font-size:var(--text-xs);line-height:var(--leading-tight);text-overflow:ellipsis;white-space:nowrap;&.cancelled{text-decoration:line-through;opacity:0.6}}.ds-slot{position:absolute;top:0;bottom:0;border:2px dashed var(--color-accent);border-radius:var(--radius-sm);background:color-mix(in srgb,var(--color-accent) 10%,transparent);pointer-events:none}.ds-note{margin:0;color:var(--color-text-muted);font-size:var(--text-sm)}
}`

  HTML = `{#if state.shown}
<div class="ds-head" data-day={props.day}>
<span>{state.title}</span>
{#if state.loading}<ui-spinner size="sm"></ui-spinner>{/if}
</div>
{#if state.allDay.length}
<div class="ds-chips">
{#each state.allDay as item}
<span class="ds-chip" key={item.key} style="--tag: var(--color-avatar-{item.color})" title={item.title}>{item.title}</span>
{/each}
</div>
{/if}
<div class="ds-track" style="height: {state.height}px">
{#each state.hours as tick}
<span class="ds-tick" key={tick.hour} style="left: {tick.left}%"><span class="ds-hour {tick.edge}">{tick.label}</span></span>
{/each}
{#each state.boxes as box}
<span class="ds-box" class:cancelled={box.cancelled} key={box.key} style="left: {box.left}%; width: {box.width}%; top: {box.top}px; height: 24px; --tag: var(--color-avatar-{box.color})" title="{box.title}, {box.range}">{box.title}</span>
{/each}
{#if props.slot && state.slot}
<span class="ds-slot" style="left: {state.slot.left}%; width: {state.slot.width}%" title="This event"></span>
{/if}
</div>
{#if state.note}<p class="ds-note">{state.note}</p>{/if}
{/if}`
};
}

Fez('calendar-day-strip', __fez_component_0);

export default __fez_component_0;
